import MATag from '../index'

/**
 * CA-LINKのタグ仕様については以下を参照
 * @see https://app.zenhub.com/workspaces/mycolor-5bcb2d454b5806bc2bedf87c/issues/my-color/front/4709
 */
export default class CALinkTag implements MATag {
  private htmlElementId: string = 'ma_product_id'
  private fkuIdsAttributeName: string = 'data-product_id'
  private _fkuIds: string[]

  constructor(fkuIds: string[] = []) {
    this.fkuIds = fkuIds
  }

  private get fkuIdsStr(): string {
    return this._fkuIds.join(',')
  }

  get htmlMetaElement(): HTMLMetaElement {
    const el = document.createElement('meta')

    el.setAttribute('id', this.htmlElementId)
    el.setAttribute(this.fkuIdsAttributeName, this.fkuIdsStr)

    return el
  }

  set fkuIds(fkuIds: string[]) {
    this._fkuIds = fkuIds
  }

  /**
   * TODO: Htmlのmetaタグ操作用のクラスを用意し、そちらに権限委譲したい。
   */
  setHtmlMetaElementTo(document: Document): void {
    const existingEl = document.getElementById(this.htmlElementId)

    if (existingEl) {
      existingEl.setAttribute(this.fkuIdsAttributeName, this.fkuIdsStr)
    } else {
      document.head.appendChild(this.htmlMetaElement)
    }
  }
}
